<template>
  <section class="page-container">
    <el-dialog title="子商品明细" :visible.sync="isShow" :close-on-click-modal="false" width="80%">
      <!--工具条-->
      <div ref="toolbar" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-input v-model="filters.sku" placeholder="SKU"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.size" placeholder="SIZE"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="filters.status" placeholder="状态" clearable>
              <el-option :value="0" label="售卖中" />
              <el-option :value="1" label="已售卖" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="filters.type" placeholder="类型" clearable>
              <el-option :value="0" label="Oversea Shipping" />
              <el-option :value="1" label="PH Based Shipping" />
              <el-option :value="2" label="AUS Based Shipping" />
              <el-option :value="3" label="AUS Based Shipping" />
              <el-option :value="4" label="MYS Based Shipping" />
              <el-option :value="5" label="MYS Based Shipping" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="list">刷新</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="handleAdd">新增</el-button>
          </el-form-item> -->
        </el-form>
      </div>

      <!--列表-->
      <div ref="mainContent" :style="{ height: mainHeight }">
        <el-table
          v-loading="listLoading"
          height="100%"
          :data="results"
          highlight-current-row
          border
          stripe
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="userId" label="用户ID"></el-table-column>
          <el-table-column prop="productId" label="商品ID"></el-table-column>
          <el-table-column prop="sku" label="SKU"></el-table-column>
          <el-table-column prop="size" label="尺码"></el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
          <el-table-column prop="type" label="类型">
            <template #default="{ row }">
              {{ productItemTypes[row.type] || row.type }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">售卖中</span>
              <span v-if="scope.row.status === 1">已售完</span>
            </template>
          </el-table-column>
          <el-table-column prop="sellerOrderNo" label="卖家订单编号"></el-table-column>
          <el-table-column prop="sellerOrderId" label="卖家订单ID"></el-table-column>
          <el-table-column prop="buyerOrderNo" label="买家订单编号"></el-table-column>
          <el-table-column prop="buyerOrderId" label="买家订单ID"></el-table-column>
          <el-table-column prop="createTime" label="创建时间">
            <template slot-scope="scope">
              {{ scope.row.createTime | formatDate }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <!-- 分页 -->
      <my-pagination
        ref="pagebar"
        :page="page"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="创建人编号">
          <el-input v-model="addForm.createUserId"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input v-model="addForm.createTime"></el-input>
        </el-form-item>
        <el-form-item label="更新人编号">
          <el-input v-model="addForm.updateUserId"></el-input>
        </el-form-item>
        <el-form-item label="修改时间">
          <el-input v-model="addForm.updateTime"></el-input>
        </el-form-item>
        <el-form-item label="isDelete">
          <el-input v-model="addForm.isDelete"></el-input>
        </el-form-item>
        <el-form-item label="userId">
          <el-input v-model="addForm.userId"></el-input>
        </el-form-item>
        <el-form-item label="productId">
          <el-input v-model="addForm.productId"></el-input>
        </el-form-item>
        <el-form-item label="size">
          <el-input v-model="addForm.size"></el-input>
        </el-form-item>
        <el-form-item label="price">
          <el-input v-model="addForm.price"></el-input>
        </el-form-item>
        <el-form-item label="status">
          <el-input v-model="addForm.status"></el-input>
        </el-form-item>
        <el-form-item label="buyerOrderNo">
          <el-input v-model="addForm.buyerOrderNo"></el-input>
        </el-form-item>
        <el-form-item label="buyerOrderId">
          <el-input v-model="addForm.buyerOrderId"></el-input>
        </el-form-item>
        <el-form-item label="sellerOrderNo">
          <el-input v-model="addForm.sellerOrderNo"></el-input>
        </el-form-item>
        <el-form-item label="sellerOrderId">
          <el-input v-model="addForm.sellerOrderId"></el-input>
        </el-form-item>
        <el-form-item label="子商品sku">
          <el-input v-model="addForm.sku"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="id">
          <el-input v-model="editForm.id"></el-input>
        </el-form-item>
        <el-form-item label="创建人编号">
          <el-input v-model="editForm.createUserId"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input v-model="editForm.createTime"></el-input>
        </el-form-item>
        <el-form-item label="更新人编号">
          <el-input v-model="editForm.updateUserId"></el-input>
        </el-form-item>
        <el-form-item label="修改时间">
          <el-input v-model="editForm.updateTime"></el-input>
        </el-form-item>
        <el-form-item label="isDelete">
          <el-input v-model="editForm.isDelete"></el-input>
        </el-form-item>
        <el-form-item label="userId">
          <el-input v-model="editForm.userId"></el-input>
        </el-form-item>
        <el-form-item label="productId">
          <el-input v-model="editForm.productId"></el-input>
        </el-form-item>
        <el-form-item label="size">
          <el-input v-model="editForm.size"></el-input>
        </el-form-item>
        <el-form-item label="price">
          <el-input v-model="editForm.price"></el-input>
        </el-form-item>
        <el-form-item label="status">
          <el-input v-model="editForm.status"></el-input>
        </el-form-item>
        <el-form-item label="buyerOrderNo">
          <el-input v-model="editForm.buyerOrderNo"></el-input>
        </el-form-item>
        <el-form-item label="buyerOrderId">
          <el-input v-model="editForm.buyerOrderId"></el-input>
        </el-form-item>
        <el-form-item label="sellerOrderNo">
          <el-input v-model="editForm.sellerOrderNo"></el-input>
        </el-form-item>
        <el-form-item label="sellerOrderId">
          <el-input v-model="editForm.sellerOrderId"></el-input>
        </el-form-item>
        <el-form-item label="子商品sku">
          <el-input v-model="editForm.sku"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
// import mainHeight from "@/utils/mainHeight";
export default {
  name: "ProductItem",
  components: { MyPagination },
  data() {
    return {
      isShow: false,
      productId: 0,
      mainHeight: "600px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,

      productItemTypes: {
        0: "PH Oversea Shipping",
        1: "PH Based Shipping",
        2: "AUS Oversea Shipping",
        3: "AUS Based Shipping",
        4: "MYS Oversea Shipping",
        5: "MYS Based Shipping",
      },
    };
  },
  mounted() {
    // mainHeight(this);
    this.list();
  },
  methods: {
    async show(productId) {
      this.isShow = true;
      this.filters.productId = productId;
      await this.list();
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("mall:/api/admin/product-item/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    async addSubmit() {
      this.addLoading = true;
      try {
        await this.axios.post("mall:/api/admin/product-item/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.addLoading = false;
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("mall:/api/admin/product-item/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      this.editLoading = true;
      try {
        await this.axios.post("mall:/api/admin/product-item/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.editLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
